import { CriteriaConfig, LogCriteria, LogFilterType } from '@src/dtos/search-criteria.dto';
import {
    AlertDropRuleAction,
    DirectionFilterNames,
    getEnumOptions,
    ThreatType,
    TimeRange
} from '@src/utils/enums';
import { checkPort } from '@src/utils/validationUtils';
import { checkSingleIp } from '@src/utils/ipValidationUtil';

// Helper to get config with Threat Type forced to DNS and disabled
export function getThreatFilteringCriteriaConfig(isAdvancedConnection: boolean = false): CriteriaConfig<LogCriteria>[] {
    return [
        {
            accessor: 'timeDetails',
            header: 'Time',
            type: LogFilterType.TIME,
            defaultValue: TimeRange.LAST_24_HOURS,
            width: 305,
            options: getEnumOptions(TimeRange),
            allowedDaysAgo: 39
        },
        {
            accessor: 'direction',
            header: 'Direction',
            type: LogFilterType.DROP_DOWN,
            options: getEnumOptions(DirectionFilterNames).filter(item => item.label !== DirectionFilterNames.BOTH),
            defaultValue: DirectionFilterNames.ALL,
            width: 170
        },
        {
            accessor: 'threatTypes',
            header: 'Threat Type',
            type: LogFilterType.MULTISELECT,
            showAllOption: false,
            options: getEnumOptions(ThreatType),
            defaultValue: isAdvancedConnection ? ThreatType.DNS : ThreatType.VIRUS,
            width: 170,
            disabled: isAdvancedConnection
        },
        {
            accessor: 'destIp',
            header: 'Destination IP',
            type: LogFilterType.INPUT,
            defaultValue: '',
            width: 140,
            validationRules: [checkSingleIp]
        },
        {
            accessor: 'dport',
            header: 'Port',
            type: LogFilterType.INPUT_NUMBER,
            defaultValue: '',
            width: 90,
            validationRules: [checkPort]
        },
        {
            accessor: 'action',
            header: 'Action',
            type: LogFilterType.DROP_DOWN,
            options: getEnumOptions(AlertDropRuleAction).map(option => option.label === AlertDropRuleAction.RESET_BOTH ?
                { label: 'Reset Both (Block)', value: AlertDropRuleAction.RESET_BOTH } : option),
            defaultValue: AlertDropRuleAction.ALL,
            width: 170
        }
    ];
}